import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { setStateValue } from '../../../../../../actions/actionsModuloRelatorio';
import * as service from '../../services';

export const useGenerateReportItem = () => {
  const dispatch = useDispatch();

  const successAction = data => {
    if (data.status === 200) {
      dispatch(setStateValue('showModalProcessingReport', true));
    } else {
      const numberOfLines = data.status === 413 ? data.data.match(/\d+/g)[0] : '0';
      dispatch(setStateValue('showModalNoDownload', data.status));
      dispatch(setStateValue('reportLineQuantity', numberOfLines));
    }
  };

  const errorAction = data => {
    const numberOfLines = data.response.status === 413 ? data.response.data.match(/\d+/g)[0] : '0';
    dispatch(setStateValue('showModalNoDownload', data.response.status));
    dispatch(setStateValue('reportLineQuantity', numberOfLines));
  };

  const generateReportItem = useMutation({
    mutationFn: id => service.generateSavedReport(id),
    onSuccess: successAction,
    onError: errorAction,
  });

  return {
    handleGenerateReportItem: generateReportItem.mutate,
  };
};
